
<script setup lang="ts">
import { defaults } from '#shared/utils/defaultDataSchema';
import logger from '#shared/utils/logger';



const isProdEnv = import.meta.env.PROD;
if(!isProdEnv) {
  // console.log("========> Development Environment <=============")
  logger.setLogLevel('debug');
} else {
  // console.log("========> Production Environment <=============")
  logger.setLogLevel('error');
}


// for reactive data you can use provide/inject to allow children components readonly and runtime access to social defaults, but for static data like this, it's simpler to just import the defaults object directly where needed, such as in the setSEO function and page components.
// provide("defaults", defaults);

// Set Global Head defaults for use in all pages. These can be overridden by page specific frontmatter and setSEO function in each page component, most are handled in the setSEO function which merges page frontmatter with these defaults, but you can also set any additional global head tags here as needed.
useHead({
  titleTemplate: (titleChunk) => {
    return (titleChunk && (titleChunk != defaults.title)) ? `${titleChunk} - ${defaults.title}` : defaults.title;
  },
  meta: [
    {
      name: 'copyright',
      content: defaults.copyright
    }
  ],
})

</script>

<!-- Use NuxtLayout -->
<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<!-- Global Styles -->
<style>
body {
  font-family: 'Roboto', sans-serif;
}

/* more css styling can be found at assets/css/main.css */
</style>